<app-patient-info [heading]="Item"></app-patient-info>
<p-panel class="col-12">
  <form [formGroup]="noteform" (ngSubmit)="save()">
    <div class="p-fluid grid">
      <div class="field col-12 md:col-4" style="padding-top: 0px">
        <span class="p-float-label ui-fluid">
          <input
            id="float-input"
            type="text"
            pInputText
            appFormErrorMessages
            formControlName="noteTitle"
          />

          <label for="float-input">
            <span class="required-asteric"> * </span>
            Title
          </label>
        </span>
      </div>
      <div class="field col-12 md:col-4" style="padding-top: 3px">
        <span class="p-float-label ui-fluid">
            <p-calendar formControlName="noteDate"
                        dataType="date"
                        [touchUI]="false"
                        appFormErrorMessages
                        [readonlyInput]="true"
                        showButtonBar="true"
                        [showIcon]="true"
                        dateFormat="mm/dd/yy"></p-calendar>

          <label for="float-input">
            <span class="required-asteric"> * </span>
            Date
          </label>
        </span>
      </div>
      <div class="field col-12 md:col-4" style="padding-top: 0px">
        <span class="ui-float-label ui-fluid">
          <span class="required-asteric floatL mt-3"> * </span>

          <p-dropdown
            dataKey="providerId"
            [options]="providerList"
            appFormErrorMessages
            formControlName="providerId"
            optionLabel="providerName"
            optionValue="providerId"
            placeholder="-Select Provider-"
          ></p-dropdown>

          <!--<label for="float-input">
                        <span class="required-asteric"> * </span>
                    </label>-->
        </span>
      </div>
    </div>
    <div class="p-fluid grid">
      <div class="field col-12 md:col-4">
        <span class="ui-float-label ui-fluid">
          <span class="required-asteric floatL mt-3"> * </span>

          <p-dropdown
            [options]="categoriesList"
            formControlName="categoryId"
            appFormErrorMessages
            optionValue="categoryId"
            (onChange)="setTempatedd()"
            placeholder="-- Select Category--"
            optionLabel="categoryName"
          ></p-dropdown>
          <label for="float-input"> </label>
        </span>
      </div>
      <div class="field col-12 md:col-4">
        <span class="ui-float-label ui-fluid">
          <p-dropdown
            [options]="TemplateList"
            formControlName="templateId"
            optionValue="notesTemplateId"
            (onChange)="getNoteTemplateData()"
            placeholder="-- Select Template--"
            optionLabel="templateName"
          ></p-dropdown>

          <label for="float-input"> </label>
        </span>
      </div>
    </div>
    <div class="col-12" *ngIf="IsTemplateData == false">
      <!--<p-editor [style]="{'height':'320px'}" formControlName="description"></p-editor>-->

      <p-editor formControlName="description" [style]="{ height: '320px' }">
      </p-editor>
    </div>
    <div class="col-12" *ngIf="IsTemplateData == true">
      <div class="carefinity_builder">
        <formio [form]="template" (change)="formioChanged($event)"></formio>
      </div>
      <appAddFormAttributes>
        <formio
          [hidden]="true"
          [form]="template"
          [viewOnly]="true"
          [readOnly]="true"
          #formioHtml
          [submission]="submission"
          [refresh]="triggerRefresh"
        ></formio>
      </appAddFormAttributes>
    </div>
    <div class="p-fluid grid">
      <div class="field col-12 md:col-1 pl-3 pt-4">
        <button
          pButton
          type="submit"
          pTooltip="Adds patient Note"
          pTooltipPosition=""
          icon="pi pi-save"
          [disabled]="noteform.invalid"
          style="
            font-size: 1.2em;
            background-color: #131f58 !important;
            color: white !important;
          "
          label="Save"
          class="p-button-plain"
        ></button>
      </div>
    </div>
  </form>
</p-panel>
